(function () {
    if (window.__socialMediaCarouselHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.socialMediaCarousel = window.Branch.socialMediaCarousel || {};
    window.Branch.socialMediaCarousel.sliders = window.Branch.socialMediaCarousel.sliders || {};
    window.__socialMediaCarouselHasFired = true;

    function initSocialMediaCarouselSlider(socialMediaCarouselSection, parent){
        let parentId = parent.getAttribute('id');
        let enable_autoscroll = socialMediaCarouselSection.getAttribute('data-enable-autoscroll') == 'true';
        let autoscroll_interval = 1000 * parseInt(socialMediaCarouselSection.getAttribute('data-autoscroll-interval'));

        let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
        
        window.Branch.socialMediaCarousel.sliders[`${parentId}`] = new Swiper(`#${parentId} .social-media-carousel__slider`, {
            slidesPerView: 1.5,
            spaceBetween: 20,
            autoplay: autoplay,
            freeMode: true,
            loop: false,
            navigation: {
                nextEl: `#${parentId} .social-media-carousel__nav-right`,
                prevEl: `#${parentId} .social-media-carousel__nav-left`,
            },
            breakpoints: {
                  600: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                900: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                  },
                  1200: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                  },
            }
        });
    }

    function actionsOnVisible(socialMediaCarouselSection, parent){
        socialMediaCarouselSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.social-media-carousel__post-image', '.social-media-carousel__post-image-container', 540);     
        initSocialMediaCarouselSlider(socialMediaCarouselSection, parent);
    }

    function initSocialMediaCarouselCallback(socialMediaCarouselSection, parent, type){
        let fromLoad = socialMediaCarouselSection.closest('.homepage-content-container') && socialMediaCarouselSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';
        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(socialMediaCarouselSection, parent);
        } else if(!socialMediaCarouselSection.closest('.homepage-content-container')) {
            actionsOnVisible(socialMediaCarouselSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = socialMediaCarouselSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

                if (
                    isVisible &&
                    socialMediaCarouselSection.getAttribute("data-interacted") !== "true"
                ) {
                    actionsOnVisible(socialMediaCarouselSection, parent);
                    socialMediaCarouselSection.setAttribute("data-interacted", "true");
                    window.removeEventListener("scroll", scrollHandler);
                }
            };

            window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.socialMediaCarousel.socialMediaCarouselInitOnLoad = function(type){
        let socialMediaCarouselSections = document.querySelectorAll('.social-media-carousel:not([data-initialized="true"])');
        socialMediaCarouselSections.forEach((socialMediaCarouselSection) => {
            let parent = socialMediaCarouselSection.closest('.shopify-section');
            socialMediaCarouselSection.setAttribute('data-initialized', true);

            if(type == 'from-copy'){
                initSocialMediaCarouselCallback(socialMediaCarouselSection, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initSocialMediaCarouselCallback, '.homepage-content-container', socialMediaCarouselSection, socialMediaCarouselSection, parent);
            }

        })  
    }

    if (document.readyState === "complete") {
        window.Branch.socialMediaCarousel.socialMediaCarouselInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.socialMediaCarousel.socialMediaCarouselInitOnLoad('regular'));
    }
  })();
